module.exports = __webpack_public_path__ + "img/computer_ipad.b30b6e86.png";